// this file is generated by update_shopify_store_data.py at 2026-09-29 21:11:10.644507
var courses = [
    {
        "course_id": "EFDB94D3-9ECE-EE11-9989-005056A76043",
        "course_version": 2,
        "name": "AIM Patient Safety Bundle: Obstetric Hemorrhage",
        "course_type": 1,
        "author_information": "The content from this activity was originally written by a team of writers, subject matter experts, and clinicians from HealthStream. The planning committee has reviewed this updated content and determined it to be appropriate for inclusion in this activity.",
        "description": "This course provides quality improvement strategies and multidisciplinary approaches to care for pregnant and postpartum patients experiencing obstetric hemorrhage including implementing an emergency management plan, quantitative assessment of blood loss, use of hemorrhage cart and medication kit and patient centered care. This course features a comprehensive overview of the Obstetric Hemorrhage AIM Patient Safety Bundle and its key elements. \r\n\r\nThe Alliance for Innovation on Maternal Health\u2019s (AIM) mission is to support best practices that make birth safer, improve maternal health outcomes, and save lives. To learn more about patient safety bundles, please visit www.saferbirth.org",
        "learning_objectives_html": "<p>After completing this learning activity, the participant should be able to:</p>\r\n<ul>\r\n    <li>Identify strategies to increase prevention and recognition of hemorrhage in pregnant and postpartum patients</li>\r\n    <li>Describe necessary components and considerations to appropriately care for patients experiencing obstetric hemorrhage</li>\r\n    <li>Implement strategies for monitoring and reviewing incidence of hemorrhage-related metrics and case review for systems learning and to support provision of respectful, equitable and supportive care for patients that experience obstetric hemorrhage</li>\r\n</ul>\r\n<p><strong>Activity Planners and Authors</strong></p>\r\n<ul>\r\n    <li>Christie Allen, MSN, RNC-NIC, CPHQ, C-ONQS (Author, Content Expert)</li>\r\n    <li>Caitlin Goodwin, DNP, APRN-CNM, RN (Nurse Planner)</li>\r\n    <li>Emmanouil Kiriakopolous, DO (Course Director)</li>\r\n    <li>Amanda Pitt, MBA, BSN, RN, RN-BC (Nurse Planner)</li>\r\n    <li>Evan McEwing, DNP, PHNA-BC, RN, CCRP, CHSE, Director, Content Development and Research, HealthStream (AP-PD)</li>\r\n    <li><span>Jessica Ellis, </span><span>RN, BSN, </span><span>Director, Content Development, </span>HealthStream (Content Reviewer)</li>\r\n    <li><span>Sheryl Ness, </span><span>BSN, MA, RN, Editorial Manager,</span><span> HealthStream (Content Reviewer)</span></li>\r\n    <li>Germaine Broussard, B.S., Sr. Development Manager, HealthStream (Content Reviewer)</li>\r\n    <li>CorShun Thurman, B.A., Accreditation Specialist, HealthStream&nbsp;</li>\r\n    <li>Melissa Pickens, BBA, Accreditation Specialist, HealthStream </li>\r\n</ul>\r\n<p>None of the planners for this educational activity have relevant financial relationship(s) to disclose with ineligible companies whose primary business is producing, marketing, selling, re-selling, or distributing healthcare products used by or on patients.</p>\r\n<p><strong>Commercial Support</strong></p>\r\n<p>This activity was not commercially supported.</p>\r\n<p><strong>Criteria for Completion </strong></p>\r\n<p>This activity contains a post-test and reflective/interactive content. You must complete the entire activity, including the evaluation, and score an 80% or higher on the post-test in order to obtain a certificate of completion. Partial credit will not be given.</p>\r\n<p>Licensees must provide their license/member numbers for record keeping purposes. Continuing education licensing/certification requirements vary by profession and state. Learners should contact their licensing/certification board or professional organization to confirm that these contact hours will be accepted. HealthStream does not warrant acceptance.</p>\r\n<p><strong>CE Release &amp; Expiration Dates</strong></p>\r\n<p><strong>ANCC (Registered Nurses)</strong></p>\r\n<p>Release Date: 2/19/2024</p>\r\n<p>Expiration Date: 2/18/2027</p>\r\n<p><strong>ACCME (Medical Providers)</strong></p>\r\n<p>Release Date: 2/19/2024</p>\r\n<p>Expiration Date: 2/18/2027</p>\r\n<p><strong>Next Review Date:</strong></p>\r\n<p>This course will be reviewed in 8/18/2026 to determine if the content is still relevant and/or needs to be updated for renewal.</p>",
        "course_outline_html": "Introduction to Obstetric Hemorrhage&nbsp;&nbsp;<br />\r\nReadiness<br />\r\nRecognition &amp; Prevention<br />\r\nResponse<br />\r\nReporting &amp; Systems Learning<br />\r\nRespectful, Equitable and Supportive Care<br />\r\nConclusion<br />\r\n<br />\r\nThese materials were developed with support from the Health Resources and Services Administration (HRSA) of the U.S. Department of Health and Human Services (HHS) as part of a cooperative agreement with the American College of Obstetricians and Gynecologists under grant number UC4MC28042, Alliance for Innovation on Maternal Health. The contents do not necessarily represent the official views of, nor an endorsement, by HRSA, HHS, or the U.S. Government. For more information, please visit HRSA.gov.<br />\r\n<div>&nbsp;</div>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "05677DF9-86DB-E311-A041-005056B1680C",
                "course_category_name": "Sponsored CE",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BF92C7B7-00C9-E511-BC00-005056B1263C",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6133B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiac Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B94A53FC-166B-E611-93E1-005056B11CD6",
                "course_category_name": "ACOG - American College of Obstetricians and Gynecologists",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7064D866-23C9-E511-8771-005056B104B1",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "64DA746D-C134-E611-B688-005056B11774",
                "course_category_name": "Free CE Courses **NEW**",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B00C705A-98FE-EA11-9229-005056B17C80",
                "course_category_name": "ACOG",
                "is_system_course_category": null
            },
            {
                "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                "course_category_name": "Obstetric Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C5E0945D-F18B-EF11-9996-005056A77B46",
                "course_category_name": "z_ContentOps \u2013 Standard Evaluation Update",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "087A0842-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Public Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DFE5D158-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CE - Continuing Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FCA35D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Anesthesiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B8E4A1C3-210C-E811-8B11-005056B160F2",
                "course_category_name": "FREE Courses **IAV**",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "28B73E63-43CF-EE11-998D-005056A7EBB6",
                "course_category_name": "AIM Patient Safety Bundle",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician (MD/DO)",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ACCME; ANCC",
            "accreditation_statement": "<p><span style=\"font-size: 11pt; font-family: calibri, sans-serif;\">For licensed professionals who use CE Broker: HealthStream will automatically report your completion to CE Broker if your licensing board is listed. You must enter your license number, state, and discipline in your HealthStream profile for successful reporting. Other professionals may self-report the completion, if appropriate. </span></p>\r\n<p><img width=\"136\" height=\"115\" style=\"width: 136px; height: 115px;\" alt=\"HealthStream Reports to CE Broker within 24hrs\" src=\"https://www.healthstream.com/content/_CEBroker/CEBrokerReportsBadge-24Hrs.png\" /></p>",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ACCME; ANCC",
            "credit_units": 1.0,
            "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
        },
        "sub_courses": []
    }
];